import { render, staticRenderFns } from "./new_and_event.vue?vue&type=template&id=8ff21cdc&scoped=true&"
import script from "./new_and_event.vue?vue&type=script&lang=js&"
export * from "./new_and_event.vue?vue&type=script&lang=js&"
import style0 from "./new_and_event.vue?vue&type=style&index=0&id=8ff21cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff21cdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
